<template>
  <div class="cart-add" v-bind:class="{ 'is-loading': loadingMain, 'is-vue-select-opened': isOpenVueSelect }">
    <div class="scroll-container" ref="scroll">
      <button type="button" class="cart-add-close" @click="onClose" ref="closeBtn">
        <i class="ico ico-cross"></i>
        <span class="hide-access">{{ Translator('front.cart.add.close') }}</span>
      </button>
      <h1 class="cart-add-title">
        <template v-if="isDupplicate">
          {{ Translator('front.cart.add.title_dupplicate') }}
        </template>
        <template v-else>
          {{ Translator('front.cart.add.title') }}
        </template>
      </h1>
      <form class="cart-form std-form" @submit="onSubmit" ref="form">
        <div class="form-group">
          <div class="radio" :class="{'is-disabled': datas && form.cardOrderItem.serviceType !== 'certification'}">
            <label v-on="!datas ? { touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } if(form.cardOrderItem.serviceType !== 'certification'){form.cardOrderItem.serviceType = 'certification';} onScroll = false; }} : {}">
              <input type="radio" :disabled="datas" value="certification" v-model="form.cardOrderItem.serviceType" @change="onUpdateTotal"> {{ Translator('front.cart.add.type_certification') }}
              <div class="form-card-help" v-if="helpsGlobal && helpsGlobal.serviceCertification">
                <button type="button" :id="'help-service-certification'" @click="onShowHelp($event, helpsGlobal.serviceCertification)">
                  <i class="ico ico-help"></i>
                  <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                </button>
              </div>
            </label>
          </div>
          <div class="radio" :class="{'is-disabled': datas && form.cardOrderItem.serviceType !== 'authentication'}">
            <label v-on="!datas ? { touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } if(form.cardOrderItem.serviceType !== 'authentication'){form.cardOrderItem.serviceType = 'authentication';} onScroll = false; }} : {}">
              <input type="radio" :disabled="datas" value="authentication" v-model="form.cardOrderItem.serviceType" @change="onUpdateTotal"> {{ Translator('front.cart.add.type_authentication') }}
              <div class="form-card-help" v-if="helpsGlobal && helpsGlobal.serviceAuthentification">
                <button type="button" :id="'help-service-authentication'" @click="onShowHelp($event, helpsGlobal.serviceAuthentification )">
                  <i class="ico ico-help"></i>
                  <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                </button>
              </div>
            </label>
          </div>
          <div class="radio" :class="{'is-disabled': datas && form.cardOrderItem.serviceType !== 're_evaluation'}">
            <label v-on="!datas ? { touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } if(form.cardOrderItem.serviceType !== 're_evaluation'){form.cardOrderItem.serviceType = 're_evaluation';} onScroll = false; }} : {}">
              <input type="radio" :disabled="datas" value="re_evaluation" v-model="form.cardOrderItem.serviceType" @change="onUpdateTotal"> {{ Translator('front.cart.add.type_re_evaluation') }}
              <div class="form-card-help" v-if="helpsGlobal && helpsGlobal.serviceReEvaluation">
                <button type="button" :id="'help-service-re_evaluation'" @click="onShowHelp($event, helpsGlobal.serviceReEvaluation)">
                  <i class="ico ico-help"></i>
                  <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                </button>
              </div>
            </label>
          </div>
        </div>
        <div class="form-group">
          <div class="radio-list radio-list--game">
            <label class="radio-list-element" :title="game.name" v-for="game in games" :key="game.id" v-on="!datas ? { touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } if(chooseGame !== game['@id']) { chooseGame = game['@id']; onChangeGame(); } onScroll = false; }} : {}">
              <input type="radio" :disabled="datas" v-model="chooseGame" :value="game['@id']" @change="onChangeGame">
              <div class="radio-list-wrapper" :class="{'is-checked': chooseGame === game['@id'] }">
                <span class="radio-list-content">
                  <template v-if="game.image && game.image.url">
                    <img :src="game.image.url" :alt="game.name">
                  </template>
                  <template v-else>
                    {{ game.name }}
                  </template>
                </span>
              </div>
            </label>
          </div>
        </div>
        <div class="form-group" v-if="languages">
          <p class="form-label-container">{{ Translator('front.cart.add.lang') }}</p>
          <div class="radio-list radio-list--small">
            <label class="radio-list-element" :title="lang.label" v-for="lang in languages" :key="lang.id" v-on="!datas ? { touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } if(form.cardOrderItem.language !== lang['@id']) { form.cardOrderItem.language = lang['@id']; onChangeLang() } onScroll = false; }} : {}">
              <input type="radio" :disabled="datas" v-model="form.cardOrderItem.language" :value="lang['@id']" @change="onChangeLang">
              <div class="radio-list-wrapper" :class="{'is-checked': form.cardOrderItem.language === lang['@id'] }">
                <span class="radio-list-content">
                  <template v-if="lang.image && lang.image.url">
                    <img :src="lang.image.url" :alt="lang.label">
                  </template>
                  <template v-else>
                    {{ lang.label }}
                  </template>
                </span>
              </div>
            </label>
          </div>
        </div>

        <div class="form-container" v-if="chooseGame && form.cardOrderItem.language">
          <p class="cart-add-subtitle">{{ Translator('front.cart.add.card.title')}}</p>
          <!--------------------------------
                          POKEMON
          ------------------------------ -->
          <template v-if="currentGame.code === 'pokemon'">
            <div class="form-group form-group--is-placeholder form-group--is-select" :class="{'is-help': helps && helps.block, 'is-loading': this.loadingBlock,'is-not-empty': form.cardOrderItem.block }">
              <div class="form-label-container">
                <label for="block">{{ Translator('front.cart.add.card.block')}}</label>
              </div>
              <select id="block" class="form-control" v-model="form.cardOrderItem.block" @change="onChangeBlock" @focus="onFocus" @blur="onBlur" :aria-describedby="helps && helps.block ? 'help-block' : null">
                <option :value="null"></option>
                <option :value="block['@id']" v-for="block in blocks" :key="block.id">{{ block.name }}</option>
              </select>
              <div class="form-card-help" v-if="helps && helps.block">
                <button type="button" id="help-block" @click="onShowHelp($event, helps.block)">
                  <i class="ico ico-help"></i>
                  <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                </button>
              </div>
            </div>
            <div class="form-group form-group--is-placeholder form-group--is-select" v-if="form.cardOrderItem.block" :class="{'is-help': helps && helps.extension, 'is-loading': this.loadingExtension,'is-not-empty': form.cardOrderItem.extension }"
            v-on="{ touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } onTouchVueSelect('select-pokemon-extension'); onScroll = false; }}">
              <div class="form-label-container">
                <label for="extension">{{ currentGame && currentGame.extensionLabel ? currentGame.extensionLabel : Translator('front.cart.add.card.extension')}}</label>
              </div>
              <v-select :options="[...extensions]" :reduce="ext => ext && ext['@id'] ? ext['@id'] : null" v-model="form.cardOrderItem.extension" label="name" ref="select-pokemon-extension" @search:blur="onBlurVueSelect('select-pokemon-extension')" @search:focus="onFocusVueSelect('select-pokemon-extension')"  @option:selected="onSelectedVueSelect('select-pokemon-extension'); onChangeExtension()">
                <div slot="no-options">{{ Translator('front.cart.add.card.no_option') }}</div>
              </v-select>
              <div class="form-card-help" v-if="helps && helps.extension">
                <button type="button" id="help-extension" @click="onShowHelp($event, helps.extension)">
                  <i class="ico ico-help"></i>
                  <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                </button>
              </div>
            </div>

            <div class="form-row" v-if="form.cardOrderItem.extension && rangeYears">
              <div>
                <div class="form-group form-group--is-placeholder form-group--is-select" :class="{'is-help': helps && helps.year, 'is-loading': this.loadingYear,'is-not-empty': form.cardOrderItem.year }">
                  <div class="form-label-container">
                    <label for="year">{{ Translator('front.cart.add.card.year')}}</label>
                  </div>
                  <select id="year" class="form-control" v-model="form.cardOrderItem.year" @change="onChangeYear" @focus="onFocus" @blur="onBlur" :aria-describedby="helps && helps.year ? 'help-year' : null">
                    <option :value="null"></option>
                    <option :value="year" v-for="year in rangeYears" :key="year">{{ year }}</option>
                  </select>
                  <div class="form-card-help" v-if="helps && helps.year">
                    <button type="button" id="help-year" @click="onShowHelp($event, helps.year)">
                      <i class="ico ico-help"></i>
                      <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <div class="form-group form-group--is-placeholder form-group--is-select" :class="{'is-help': helps && helps.extensionCode, 'is-loading': this.loadingExtensionCode,'is-not-empty': form.cardOrderItem.extensionCode }" v-if="form.cardOrderItem.year"
                v-on="{ touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } onTouchVueSelect('select-pokemon-code'); onScroll = false; }}">
                  <div class="form-label-container">
                    <label for="extension_code">{{ currentGame && currentGame.extensionCodeLabel ? currentGame.extensionCodeLabel : Translator('front.cart.add.card.extension_code')}}</label>
                  </div>
                  <v-select :options="[...extensionsCode]" :reduce="ext => ext && ext['@id'] ? ext['@id'] : null" v-model="form.cardOrderItem.extensionCode" label="name" ref="select-pokemon-code" @search:blur="onBlurVueSelect('select-pokemon-code')" @search:focus="onFocusVueSelect('select-pokemon-code')" @option:selected="onSelectedVueSelect('select-pokemon-code'); onChangeExtensionCode()">
                    <div slot="no-options">{{ Translator('front.cart.add.card.no_option') }}</div>
                  </v-select>
                  <div class="form-card-help" v-if="helps && helps.extensionCode">
                    <button type="button" id="help-extensionCode" @click="onShowHelp($event, helps.extensionCode)">
                      <i class="ico ico-help"></i>
                      <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row" v-if="form.cardOrderItem.year && form.cardOrderItem.extensionCode">
              <div>
                <div class="form-group form-group--is-placeholder" :class="{'is-help': helps && helps.customExtensionNumber, 'is-not-empty': form.cardOrderItem.customExtensionNumber }">
                  <div class="form-label-container">
                    <label for="number">{{ Translator('front.cart.add.card.customExtensionNumber')}}</label>
                  </div>
                  <input :disabled="hasNoNumber" type="text" class="form-control" v-model="form.cardOrderItem.customExtensionNumber" id="number" autocomplete="off" @focus="onFocus" @blur="onBlur" :aria-describedby="helps && helps.customExtensionNumber ? 'help-customExtensionNumber' : null">
                  <div class="form-card-help" v-if="helps && helps.customExtensionNumber">
                    <button type="button" id="help-customExtensionNumber" @click="onShowHelp($event, helps.customExtensionNumber)">
                      <i class="ico ico-help"></i>
                      <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-group" style="align-self: center;">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="hasNoNumber" @change="onChangeNoNumber">
                    {{ Translator('front.cart.add.card.no_number')}}
                  </label>
                </div>
              </div>
            </div>
          </template>
          <!--------------------------------
                          YUGIOH
          ------------------------------ -->
          <template v-else-if="currentGame.code === 'yugioh'">
            <div class="form-group form-group--is-placeholder form-group--is-select" :class="{'is-help': helps && helps.extensionCode, 'is-loading': this.loadingExtensionCode,'is-not-empty': form.cardOrderItem.extensionCode }"
            v-on="{ touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } onTouchVueSelect('select-ygo-code'); onScroll = false; }}">
              <div class="form-label-container">
                <label for="extension_code">{{ currentGame && currentGame.extensionCodeLabel ? currentGame.extensionCodeLabel : Translator('front.cart.add.card.extension_code')}}</label>
              </div>
              <v-select :options="[...extensionsCode]" :reduce="ext => ext && ext['@id'] ? ext['@id'] : null" v-model="form.cardOrderItem.extensionCode" label="name" ref="select-ygo-code" @search:blur="onBlurVueSelect('select-ygo-code')" @search:focus="onFocusVueSelect('select-ygo-code')" @option:selected="onSelectedVueSelect('select-ygo-code'); onChangeExtensionCode()">
                <div slot="no-options">{{ Translator('front.cart.add.card.no_option') }}</div>
              </v-select>
              <div class="form-card-help" v-if="helps && helps.extensionCode">
                <button type="button" id="help-extensionCode" @click="onShowHelp($event, helps.extensionCode)">
                  <i class="ico ico-help"></i>
                  <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                </button>
              </div>
            </div>
            <div class="form-row" v-if="form.cardOrderItem.extensionCode">
              <div>
                <div class="form-group form-group--is-placeholder form-group--is-select" :class="{'is-help': helps && helps.languageCodeYGO, 'is-loading': this.loadingCodeYGO,'is-not-empty': form.cardOrderItem.languageCodeYGO }">
                  <div class="form-label-container">
                    <label for="codeYGO">{{ Translator('front.cart.add.card.code_ygo')}}</label>
                  </div>
                  <select id="codeYGO" class="form-control" v-model="form.cardOrderItem.languageCodeYGO" @focus="onFocus" @blur="onBlur" :aria-describedby="helps && helps.languageCodeYGO ? 'help-languageCodeYGO' : null">
                    <option :value="null"></option>
                    <option :value="code['@id']" v-for="code in codesYGO" :key="code.id">{{ code.value }}</option>
                  </select>
                  <div class="form-card-help" v-if="helps && helps.languageCodeYGO">
                    <button type="button" id="help-languageCodeYGO" @click="onShowHelp($event, helps.languageCodeYGO)">
                      <i class="ico ico-help"></i>
                      <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div>
                <div class="form-group form-group--is-placeholder form-group--is-select" :class="{'is-help': helps && helps.additionnalLetterYGO, 'is-loading': this.loadingLetterYGO,'is-not-empty': form.cardOrderItem.additionnalLetterYGO }">
                  <div class="form-label-container">
                    <label for="letterYGO">{{ Translator('front.cart.add.card.letter_ygo')}}</label>
                  </div>
                  <select id="letterYGO" class="form-control" v-model="form.cardOrderItem.additionnalLetterYGO" @focus="onFocus" @blur="onBlur" :aria-describedby="helps && helps.additionnalLetterYGO ? 'help-additionnalLetterYGO' : null">
                    <option :value="null"></option>
                    <option :value="letter['@id']" v-for="letter in lettersYGO" :key="letter.id">{{ letter.value }}</option>
                  </select>
                  <div class="form-card-help" v-if="helps && helps.additionnalLetterYGO">
                    <button type="button" id="help-additionnalLetterYGO" @click="onShowHelp($event, helps.additionnalLetterYGO)">
                      <i class="ico ico-help"></i>
                      <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-row" v-if="form.cardOrderItem.extensionCode">
              <div>
                <div class="form-group form-group--is-placeholder" :class="{'is-help': helps && helps.customExtensionNumber, 'is-not-empty': form.cardOrderItem.customExtensionNumber }">
                  <div class="form-label-container">
                    <label for="number">{{ Translator('front.cart.add.card.customExtensionNumber')}}</label>
                  </div>
                  <input :disabled="hasNoNumber" type="text" class="form-control" v-model="form.cardOrderItem.customExtensionNumber" id="number" autocomplete="off" @focus="onFocus" @blur="onBlur" :aria-describedby="helps && helps.customExtensionNumber ? 'help-customExtensionNumber' : null">
                  <div class="form-card-help" v-if="helps && helps.customExtensionNumber">
                    <button type="button" id="help-customExtensionNumber" @click="onShowHelp($event, helps.customExtensionNumber)">
                      <i class="ico ico-help"></i>
                      <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div v-if="currentLanguage && (currentLanguage.code === 'JAP' || currentLanguage.code === 'JP' || currentLanguage.code === 'AE')" style="align-self: center;">
                <div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" v-model="hasNoNumber" @change="onChangeNoNumber">
                      {{ Translator('front.cart.add.card.no_number')}}
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <p class="card-add-code-info" v-if="(form.cardOrderItem.customExtensionNumber || (hasNoNumber && currentLanguage && (currentLanguage.code === 'JAP' || currentLanguage.code === 'JP' || currentLanguage.code === 'AE'))) && extensionsCode && extensionsCode.length > 0 && codesYGO && codesYGO.length > 0 && lettersYGO && lettersYGO.length > 0">
              {{ Translator('front.cart.add.card.card_info')}} :
              <strong>
                <span v-if="form.cardOrderItem.extensionCode">{{ getName(form.cardOrderItem.extensionCode, extensionsCode).name }}</span><span v-if="form.cardOrderItem.languageCodeYGO || form.cardOrderItem.additionnalLetterYGO || form.cardOrderItem.customExtensionNumber">-</span><span v-if="form.cardOrderItem.languageCodeYGO">{{ getName(form.cardOrderItem.languageCodeYGO, codesYGO).value }}</span><span v-if="form.cardOrderItem.additionnalLetterYGO">{{ getName(form.cardOrderItem.additionnalLetterYGO, lettersYGO).value }}</span><span v-if="form.cardOrderItem.customExtensionNumber">{{ form.cardOrderItem.customExtensionNumber }}</span>
              </strong>
            </p>
            <div class="form-group form-group--is-placeholder form-group--is-select" :class="{'is-help': helps && helps.extension, 'is-loading': this.loadingExtension,'is-not-empty': form.cardOrderItem.extension }"
            v-if="!currentGame.isExtensionOptional && (form.cardOrderItem.customExtensionNumber || (hasNoNumber && currentLanguage && (currentLanguage.code === 'JAP' || currentLanguage.code === 'JP' || currentLanguage.code === 'AE')))"
            v-on="{ touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } onTouchVueSelect('select-ygo-extension'); onScroll = false; }}">
              <div class="form-label-container">
                <label for="extension">{{ currentGame && currentGame.extensionLabel ? currentGame.extensionLabel : Translator('front.cart.add.card.extension')}}</label>
              </div>
              <v-select :options="[...extensions]" :reduce="ext => ext && ext['@id'] ? ext['@id'] : null" v-model="form.cardOrderItem.extension" label="name" ref="select-ygo-extension" @search:blur="onBlurVueSelect('select-ygo-extension')" @search:focus="onFocusVueSelect('select-ygo-extension')" @option:selected="onSelectedVueSelect('select-ygo-extension'); onChangeExtension()">
                <div slot="no-options">{{ Translator('front.cart.add.card.no_option') }}</div>
              </v-select>
              <div class="form-card-help" v-if="helps && helps.extension">
                <button type="button" id="help-extension" @click="onShowHelp($event, helps.extension)">
                  <i class="ico ico-help"></i>
                  <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                </button>
              </div>
            </div>
            <div class="form-row" v-if="!currentGame.isYearOptional">
              <div class="form-group form-group--is-placeholder form-group--is-select" :class="{'is-help': helps && helps.year, 'is-loading': this.loadingYear,'is-not-empty': form.cardOrderItem.year }" v-if="(form.cardOrderItem.customExtensionNumber || (hasNoNumber && currentLanguage && (currentLanguage.code === 'JAP' || currentLanguage.code === 'JP' || currentLanguage.code === 'AE'))) && form.cardOrderItem.extensionCode && form.cardOrderItem.extension">
                <div class="form-label-container">
                  <label for="year">{{ Translator('front.cart.add.card.year')}}</label>
                </div>
                <select id="year" class="form-control" v-model="form.cardOrderItem.year" @change="onChangeYear" @focus="onFocus" @blur="onBlur" :aria-describedby="helps && helps.year ? 'help-year' : null">
                  <option :value="null"></option>
                  <option :value="year" v-for="year in rangeYears" :key="year">{{ year }}</option>
                </select>
                <div class="form-card-help" v-if="helps && helps.year">
                  <button type="button" id="help-year" @click="onShowHelp($event, helps.year)">
                    <i class="ico ico-help"></i>
                    <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                  </button>
                </div>
              </div>
              <div></div>
              <div></div>
            </div>
          </template>
          <!--------------------------------
                          OTHERS
          ------------------------------ -->
          <template v-else>
            <div class="form-row">
              <div class="form-group form-group--is-placeholder form-group--is-select" :class="{'is-help': helps && helps.extensionCode, 'is-loading': this.loadingExtensionCode, 'is-not-empty': form.cardOrderItem.extensionCode }"
              v-on="{ touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } onTouchVueSelect('select-other-code'); onScroll = false; }}">
                <div class="form-label-container">
                  <label for="extension_code">{{ currentGame && currentGame.extensionCodeLabel ? currentGame.extensionCodeLabel : Translator('front.cart.add.card.extension_code')}}</label>
                </div>
                <v-select :disabled="hasNoCode" :options="[...extensionsCode]" :reduce="ext => ext && ext['@id'] ? ext['@id'] : null" v-model="form.cardOrderItem.extensionCode" label="name" ref="select-other-code" @search:blur="onBlurVueSelect('select-other-code')" @search:focus="onFocusVueSelect('select-other-code')" @option:selected="onSelectedVueSelect('select-other-code'); onChangeExtensionCode()">
                  <div slot="no-options">{{ Translator('front.cart.add.card.no_option') }}</div>
                </v-select>
                <div class="form-card-help" v-if="helps && helps.extensionCode">
                  <button type="button" id="help-extensionCode" @click="onShowHelp($event, helps.extensionCode)">
                    <i class="ico ico-help"></i>
                    <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                  </button>
                </div>
              </div>
              <div class="form-group" style="align-self: center;">
                <div class="checkbox" v-if="!currentGame.isExtensionOptional">
                  <label>
                    <input type="checkbox" v-model="hasNoCode" @change="onChangeNoCode">
                    {{ Translator('front.cart.add.card.no_code')}}
                  </label>
                </div>
              </div>
            </div>
            <div class="form-group form-group--is-placeholder form-group--is-select" :class="{'is-help': helps && helps.extension, 'is-loading': this.loadingExtension, 'is-not-empty': form.cardOrderItem.extension }"
            v-if="!currentGame.isExtensionOptional && (form.cardOrderItem.extensionCode || hasNoCode)"
            v-on="{ touchmove: () => { onScroll = true; }, touchend: () => { if(onScroll) { onScroll = false; return; } onTouchVueSelect('select-other-extension'); onScroll = false; }}">
              <div class="form-label-container">
                <label for="extension">{{ currentGame && currentGame.extensionLabel ? currentGame.extensionLabel : Translator('front.cart.add.card.extension')}}</label>
              </div>
              <v-select :options="[...extensions]" :reduce="ext => ext && ext['@id'] ? ext['@id'] : null" v-model="form.cardOrderItem.extension" label="name" ref="select-other-extension" @search:blur="onBlurVueSelect('select-other-extension')" @search:focus="onFocusVueSelect('select-other-extension')" @option:selected="onSelectedVueSelect('select-other-extension'); onChangeExtension()">
                <div slot="no-options">{{ Translator('front.cart.add.card.no_option') }}</div>
              </v-select>
              <div class="form-card-help" v-if="helps && helps.extension">
                <button type="button" id="help-extension" @click="onShowHelp($event, helps.extension)">
                  <i class="ico ico-help"></i>
                  <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                </button>
              </div>
            </div>
            <div class="form-row" v-if="!currentGame.isYearOptional">
              <div>
                <div class="form-group form-group--is-placeholder form-group--is-select" :class="{'is-help': helps && helps.year, 'is-loading': this.loadingYear, 'is-not-empty': form.cardOrderItem.year }" v-if="form.cardOrderItem.extension">
                  <div class="form-label-container">
                    <label for="year">{{ Translator('front.cart.add.card.year')}}</label>
                  </div>
                  <select id="year" class="form-control" v-model="form.cardOrderItem.year" @change="onChangeYear" @focus="onFocus" @blur="onBlur" :aria-describedby="helps && helps.year ? 'help-year' : null">
                    <option :value="null"></option>
                    <option :value="year" v-for="year in rangeYears" :key="year">{{ year }}</option>
                  </select>
                  <div class="form-card-help" v-if="helps && helps.year">
                    <button type="button" id="help-year" @click="onShowHelp($event, helps.year)">
                      <i class="ico ico-help"></i>
                      <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div></div>
            </div>
            <div class="form-row" v-if="form.cardOrderItem.year || currentGame.isYearOptional || currentGame.isExtensionOptional">
              <div>
                <div class="form-group form-group--is-placeholder" :class="{'is-help': helps && helps.customExtensionNumber, 'is-not-empty': form.cardOrderItem.customExtensionNumber }">
                  <div class="form-label-container">
                    <label for="number">{{ Translator('front.cart.add.card.customExtensionNumber')}}</label>
                  </div>
                  <input :disabled="hasNoNumber" type="text" class="form-control" v-model="form.cardOrderItem.customExtensionNumber" id="number" autocomplete="off" @focus="onFocus" @blur="onBlur" :aria-describedby="helps && helps.customExtensionNumber ? 'help-customExtensionNumber' : null">
                  <div class="form-card-help" v-if="helps && helps.customExtensionNumber">
                    <button type="button" id="help-customExtensionNumber" @click="onShowHelp($event, helps.customExtensionNumber)">
                      <i class="ico ico-help"></i>
                      <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div class="form-group" style="align-self: center;">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="hasNoNumber" @change="onChangeNoNumber">
                    {{ Translator('front.cart.add.card.no_number')}}
                  </label>
                </div>
              </div>
            </div>
          </template>
          <div class="form-group form-group--is-placeholder" v-if="isCardValid()" :class="{'is-help': helps && helps.name, 'is-not-empty': form.cardOrderItem.name }">
            <div class="form-label-container">
              <label for="name">{{ Translator('front.cart.add.card.name')}}</label>
            </div>
            <input type="text" class="form-control" v-model="form.cardOrderItem.name" id="name" autocomplete="off" @focus="onFocus" @blur="onBlur" :aria-describedby="helps && helps.name ? 'help-name' : null">
            <p class="form-help" v-html="Translator('front.cart.add.card.help')"></p>
            <div class="form-card-help" v-if="helps && helps.name">
              <button type="button" id="help-name" @click="onShowHelp($event, helps.name)">
                <i class="ico ico-help"></i>
                <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
              </button>
            </div>
          </div>
          <div class="form-step" v-if="!isCartValidated">
            <button type="button" class="form-button" :disabled="!isCardValid() || this.form.cardOrderItem.name === ''" @click="onValidateCard">{{ Translator('front.cart.add.card.btn_step') }}</button>
          </div>
        </div>
        <div class="form-container" v-if="isCardValid() && this.form.cardOrderItem.name !== '' && isCartValidated && (specificitiesCheckbox.length > 0 || specificitiesSelect.length > 0)" ref="specificities">
          <p class="cart-add-subtitle">{{ Translator('front.cart.add.specificity.title')}}</p>
          <div class="form-group" v-for="specificity in specificitiesCheckbox" :key="specificity.id">
            <div class="checkbox">
              <label>
                <input type="checkbox" :value="specificity['@id']" v-model="form.cardOrderItem.specificities" :aria-describedby="'help-specificity' + specificity.id"> {{ specificity.name }}
                <div class="form-card-help" v-if="specificity.helpText">
                  <button type="button" :id="'help-specificity' + specificity.id" @click="onShowHelp($event, {title: specificity.name, content: specificity.helpText})">
                    <i class="ico ico-help"></i>
                    <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                  </button>
                </div>
              </label>
            </div>
          </div>
          <div class="form-group form-group--is-placeholder form-group--is-select" v-if="specificitiesSelect && specificitiesSelect.length > 0" :class="{'is-help': specificitiesSelectHelps.length > 0, 'is-not-empty': form.cardOrderItem.specificitiesSelect }">
            <div class="form-label-container">
              <label for="specificities-select">{{ Translator('front.cart.add.specificity.select_label')}}</label>
            </div>
            <select id="specificities-select" class="form-control" v-model="form.cardOrderItem.specificitiesSelect" @focus="onFocus" @blur="onBlur">
              <option :value="null"></option>
              <option :value="specificity['@id']" v-for="specificity in specificitiesSelect" :key="specificity['@id']">{{ specificity.name }}</option>
            </select>
            <div class="form-card-help" v-if="specificitiesSelectHelps.length > 0">
              <button type="button" id="help-name" @click="onShowHelp($event, specificitiesSelectHelps)">
                <i class="ico ico-help"></i>
                <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
              </button>
            </div>
          </div>

          <div class="form-step" v-if="!isSpecificitiesValidated">
            <button type="button" class="form-button" @click="onValidateSpecificities">{{ Translator('front.cart.add.specificity.btn_step') }}</button>
          </div>
        </div>
        <div class="form-container" v-if="isCardValid() && this.form.cardOrderItem.name !== '' && isCartValidated && (isSpecificitiesValidated || (specificitiesCheckbox.length === 0 && specificitiesSelect.length === 0))" ref="assurances">
          <p class="cart-add-subtitle">{{ Translator('front.cart.add.assurance.title')}}</p>
          <div class="form-group form-group--is-placeholder" :class="{'is-help': helps && helps.value, 'is-not-empty': form.cardOrderItem.value }" ref="form-value">
            <div class="form-label-container">
              <label for="assurance">{{ Translator('front.cart.add.assurance.value')}}</label>
            </div>
            <div class="form-control-group form-control-group--suffix">
              <input type="number" class="form-control" v-model="form.cardOrderItem.value" min="1" id="assurance" autocomplete="off" @focus="onFocusAssurance" @blur="onChangeAssurance" @change="onChangeAssurance" @keyup="onChangeAssurance">
              <p class="form-control-suffix">€</p>
            </div>
            <div class="form-card-help" v-if="helps && helps.value">
              <button type="button" id="help-year" @click="onShowHelp($event, helps.value)">
                <i class="ico ico-help"></i>
                <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
              </button>
            </div>
            <p class="form-help" v-html="Translator('front.cart.add.assurance.value_help')"></p>
          </div>

          <div class="card-option-loader" v-if="loadingOptions"></div>
          <template v-if="!loadingOptions">
            <div class="form-row form-row--value form-row--option" v-for="item in options" :key="item.id">
              <div>
                <div class="form-group">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" :value="item.variants[0]['@id']" v-model="form.cardOrderItem.options" @change="onUpdateTotal">
                      <div class="checkbox-container">
                        <p class="checkbox-label">{{ item.name }}</p>
                        <div class="form-card-help" v-if="item.description">
                          <button type="button" id="help-option" @click="onShowHelp($event, {title: item.name, content: item.description})">
                            <i class="ico ico-help"></i>
                            <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                          </button>
                        </div>
                        <div class="form-help" v-html="item.shortDescription"></div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <div>
                <p class="cart-add-value">{{ ((item.variants[0].priceTtc || 0) / 100) | toFixed(2) }} €</p>
              </div>
            </div>
          </template>
          <div class="form-row form-row--value">
            <div>
              <div class="form-group">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="form.cardOrderItem.insurance" @change="onUpdateTotal">
                    <div class="checkbox-container">
                      {{ Translator('front.cart.add.assurance.insurance') }}
                      <div class="form-card-help" v-if="helpsGlobal && helpsGlobal.insurance_help">
                        <button type="button" id="help-insurance_help" @click="onShowHelp($event, helpsGlobal.insurance_help)">
                          <i class="ico ico-help"></i>
                          <span class="hide-access">{{ Translator('front.cart.add.help_label')}}</span>
                        </button>
                      </div>
                      <p class="form-help">{{ Translator('front.cart.add.assurance.insurance_help') }}</p>
                    </div>
                  </label>
                </div>
              </div>
            </div>
            <div>
              <p class="cart-add-value">{{ (insurance_value || 0) | toFixed(2) }} €</p>
            </div>
          </div>
        </div>
        <div class="form-container" v-if="total !== null && isCardValid() && this.form.cardOrderItem.name !== '' && isCartValidated && (isSpecificitiesValidated || (specificitiesCheckbox.length === 0 && specificitiesSelect.length === 0))">
          <div class="form-row form-row--value">
            <p class="cart-add-total">{{ Translator('front.cart.add.total.title')}}</p>
            <p class="cart-add-value">{{ (total || 0) | toFixed(2) }} €</p>
          </div>
          <p class="form-error cart-add-error" v-if="errorMessage">{{ errorMessage }}</p>
          <button type="submit" class="form-button form-button--full" :class="{'is-loading': this.isAddingItem }">{{ Translator('front.cart.add.total.btn') }}</button>
        </div>
      </form>
      <help v-if="isHelpShow" v-bind:datas="helpDatas" :scroll="$refs.scroll.scrollTop" :origin="helpParent" @close="isHelpShow = false"></help>
    </div>
  </div>
</template>
<script>
import { gsap } from 'gsap/all';
import debounce from 'debounce';
import AppControlService from '@/services/AppControl';
import GamesService from '@/services/Games';
import ProductsService from '@/services/Products';
import OrdersService from '@/services/Orders';
import Help from '@/components/Help';
import _debounce from 'debounce';

const currentYear = (new Date()).getFullYear();
export default {
  props: ['datas', 'isDupplicate'],
  name: 'cart-add',
  components: {
    Help
  },
  data () {
    return {
      isOpenVueSelect: false,
      isCartValidated: false,
      isSpecificitiesValidated: false,
      onScroll: null,
      currentScrollPosition: 0,
      currentGame: null,
      currentLanguage: null,
      loadingMain: true,
      loadingHelps: false,
      loadingCodeYGO: false,
      loadingLetterYGO: false,
      loadingExtensionCode: false,
      loadingBlock: false,
      loadingExtension: false,
      loadingSpecificities: false,
      loadingYear: false,
      errorMessage: null,
      specificitiesCheckbox: null,
      specificitiesSelectHelps: [],
      specificitiesSelect: null,
      options: [],
      loadingOptions: false,
      games: null,
      languages: null,
      helps: {},
      helpsGlobal: {},
      isHelpShow: false,
      helpDatas: null,
      helpParent: null,
      extensions: null,
      blocks: null,
      extensionsCode: null,
      codesYGO: null,
      lettersYGO: null,
      rangeYears: null,
      insurance_value: 0,
      total: null,
      hasNoNumber: false,
      hasNoCode: false,
      chooseGame: null,
      isAddingItem: false,
      previousCardOrderItem: '',
      form: {
        variant: null,
        options: [],
        cardOrderItem: {
          name: '',
          value: '',
          year: null,
          language: null,
          insurance: false,
          serviceType: 'certification',
          customExtensionNumber: '',
          languageCodeYGO: null,
          additionnalLetterYGO: null,
          extensionCode: null,
          extension: null,
          block: null,
          options: [],
          specificities: [],
          specificitiesSelect: null,
        },
      }
    }
  },

  created() {
    this.getOptions = this.getOptions.bind(this);
    this.getOptions = debounce(this.getOptions, 300);
    GamesService.getAll().then( games => {
      this.games = games;
      if(!this.datas) this.loadingMain = false;
      else {
        this.chooseGame = this.datas.cardOrderItem.game['@id'];
        const game = GamesService.getGame( this.chooseGame, '@id' );
        this.currentGame = game;
        this.form = {
          variant: this.datas.variant,
          cardOrderItem: {
            language: this.datas.cardOrderItem.language['@id'],
            serviceType: this.datas.cardOrderItem.serviceType,
            customExtensionNumber: this.datas.cardOrderItem.customExtensionNumber,

            name: this.datas.cardOrderItem.name,
            value: this.datas.cardOrderItem.value / 100,
            insurance: this.datas.cardOrderItem.insurance,
            specificities: [],
            options: []
          }
        }
        if(this.datas.cardOrderItem.year) {
          this.form.cardOrderItem.year = this.datas.cardOrderItem.year
        }
        if(this.datas.cardOrderItem.extension) {
          this.form.cardOrderItem.extension = this.datas.cardOrderItem.extension['@id'];
        }
        if(this.datas.cardOrderItem.extensionCode && this.datas.cardOrderItem.extensionCode['@id']) {
          this.form.cardOrderItem.extensionCode = this.datas.cardOrderItem.extensionCode['@id'];
        }

        if(this.datas.options && this.datas.options.length > 0) {
          this.form.cardOrderItem.options = this.datas.options.map( option => option.variant['@id']);
        }
        if(this.currentGame.code === 'pokemon' && this.datas.cardOrderItem.block) this.form.cardOrderItem.block = this.datas.cardOrderItem.block['@id'];
        if(this.datas.cardOrderItem.languageCodeYGO) this.form.cardOrderItem.languageCodeYGO = this.datas.cardOrderItem.languageCodeYGO['@id'];
        if(this.datas.cardOrderItem.additionnalLetterYGO) this.form.cardOrderItem.additionnalLetterYGO = this.datas.cardOrderItem.additionnalLetterYGO['@id'];
        if(!this.datas.cardOrderItem.customExtensionNumber) this.hasNoNumber = true;
        if(!this.datas.cardOrderItem.extensionCode) this.hasNoCode = true;

        this.insurance_value = this.form.cardOrderItem.value * 2 / 100;
        this.languages = this.currentGame.languages;
        this.onChangeLang();
        Promise.all([this._getYGO(), this._getBlocks(), this._getExtensions(), this._getExtensionsCode(), this._getSpecificities(), this._getHelps()]).then( () => {
          setTimeout(() => {
            if(this.datas.cardOrderItem.extension && this.datas.cardOrderItem.extension['@id']) {
              this.form.cardOrderItem.extension = this.datas.cardOrderItem.extension['@id'];
            }
            if(this.datas.cardOrderItem.extensionCode && this.datas.cardOrderItem.extensionCode['@id']) {
              this.form.cardOrderItem.extensionCode = this.datas.cardOrderItem.extensionCode['@id'];
            }
            this._getRangeYears();
            this._updateTotal();
            this.getOptions();
            this.specificitiesSelect.forEach( specificity => {
              this.datas.cardOrderItem.specificities.forEach( item => {
                if(specificity['@id'] === item['@id']) this.form.cardOrderItem.specificitiesSelect = item['@id'];
              });
            });
            this.specificitiesCheckbox.forEach( specificity => {
              this.datas.cardOrderItem.specificities.forEach( item => {
                if(specificity['@id'] === item['@id']) this.form.cardOrderItem.specificities.push(item['@id']);
              });
            });

            setTimeout(() => {
              this.isCartValidated = true;
              this.isSpecificitiesValidated = true;
              this.loadingMain = false;
            });
          });
        });
      }
    })
  },
  mounted() {
    this._updateTotal = _debounce(this._updateTotal, 400);
    this.$refs.closeBtn.focus();
    this._getHelps(true);
  },
  methods: {
    getName(value, group) {
      if( group) {
        for(let i = 0; i < group.length; i++) {
          if(group[i]['@id'] === value) return group[i];
        }
      }
      return null;
    },

    onSelectedVueSelect(code) {
      const el = this.$refs[code];
      setTimeout(() => {
        el.open = false;
      });
    },

    onTouchVueSelect(code) {
      const el = this.$refs[code];
      el.$refs.search.focus();
    },

    onFocusVueSelect(code) {
      const el = this.$refs[code].$el;
      el.closest('.form-group').classList.add('is-focus');
      this.isOpenVueSelect = true;
    },

    onBlurVueSelect(code) {
      const el = this.$refs[code].$el;
      const group =  el.closest('.form-group');
      group.classList.remove('is-focus');

      this.isOpenVueSelect = false;
    },

    onFocus(pEvt) {
      pEvt.target.closest('.form-group').classList.add('is-focus');
    },

    onBlur(pEvt) {
      const el = pEvt.target;
      const group =  el.closest('.form-group');
      group.classList.remove('is-focus', 'is-error');

      this._scrollToBottom();
    },

    onShowHelp(pEvt, help) {
      const helpParent = pEvt.target.closest('.form-group');
      if(this.isHelpShow && this.helpParent === helpParent) {
        this.isHelpShow = false;
        document.body.classList.remove('is-popin-help-open');
        return;
      }
      this.helpParent = helpParent;
      this.helpDatas = help;
      this.isHelpShow = true;
      document.body.classList.add('is-popin-help-open');
      if(window.innerWidth >= 768) {
        setTimeout(() => {
          const positions = helpParent.getBoundingClientRect();
          gsap.to(this.$refs.scroll, {duration: .6, scrollTo: positions.top + this.$refs.scroll.scrollTop - 50});
        }, 500);
      }
    },

    onClose() {
      AppControlService.closeAddCard();
    },

    onFocusAssurance(pEvt) {
      this.onChangeAssurance();
      this.onFocus(pEvt);
    },

    onChangeAssurance() {
      if(this.previousCardOrderItem === this.form.cardOrderItem.value) return;
      if(this.form.cardOrderItem.value < 1) this.form.cardOrderItem.value = '';
      else this.insurance_value = this.form.cardOrderItem.value * 2 / 100;
      this.previousCardOrderItem = this.form.cardOrderItem.value;
      this.getOptions();
      this._updateTotal();
    },

    getOptions() {
      if(this._previousAssurance === this.form.cardOrderItem.value) return;
      this._previousAssurance = this.form.cardOrderItem.value;
      this.loadingOptions = true;
      this.options = [];
      ProductsService.getAll({
        declaredValue: this.form.cardOrderItem.value * 100
      }).then( res => {
        this.options = res.data['hydra:member'];
      }).then( () => {
        this.loadingOptions = false;
      })
    },

    onChangeGame() {
      this.form.cardOrderItem.language = null;
      this._resetCart();
      this._resetSpecificities();
      this._resetAssurance();
      const game = GamesService.getGame( this.chooseGame, '@id' );
      this.currentGame = game;
      this.languages = this.currentGame.languages;
      this._updateTotal();
      this._scrollToBottom();
    },

    onChangeLang() {
      if(!this.loadingMain) {
        this._resetCart();
        this._resetSpecificities();
        this._resetAssurance();
        this._getSpecificities();
        this._getHelps();
      }
      this.currentLanguage = GamesService.getLanguage(this.languages, this.form.cardOrderItem.language, '@id');
      if(!this.loadingMain) {
        if(this.currentGame.code === 'pokemon') this._getBlocks();
        else this._getExtensionsCode();

        if(this.currentGame.code === 'yugioh') this._getYGO();
        this._scrollToBottom();
      }
    },

    onChangeBlock() {
      this.isCartValidated = false;
      this._resetSpecificities();
      this._resetAssurance();
      this._getExtensions();
    },

    onChangeExtensionCode(datas) {
      if(datas) this.$set(this.form.cardOrderItem, 'extensionCode', datas['@id']);

      this._resetSpecificities();
      this._resetAssurance();
      if(this.currentGame.code !== 'pokemon') this._getExtensions();
      if(this.currentGame.code === 'yugioh') {
        this.form.cardOrderItem.languageCodeYGO = null;
        this.form.cardOrderItem.additionnalLetterYGO = null;
      }
      if(!this.loadingMain) this._scrollToBottom();
    },

    onChangeExtension() {
      this.isCartValidated = false;

      this._resetSpecificities();
      this._resetAssurance();
      if(this.form.cardOrderItem.extension) this._getRangeYears();
      if(this.currentGame.code === 'pokemon') this.extensionsCode = null;
      if(!this.loadingMain) this._scrollToBottom();
    },

    onChangeYear() {
      this.isCartValidated = false;
      this._resetSpecificities();
      this._resetAssurance();
      if(this.currentGame.code === 'pokemon') {
        this._getExtensionsCode();
      }
    },

    onChangeNoNumber() {
      if(this.hasNoNumber) this.form.cardOrderItem.customExtensionNumber = null;
      else this.form.cardOrderItem.customExtensionNumber = '';
    },

    onChangeNoCode() {
      if(this.hasNoCode) this.form.cardOrderItem.extensionCode = null;
      else this.form.cardOrderItem.extensionCode = '';
      this.onChangeExtensionCode();
    },

    onUpdateTotal() {
      this._updateTotal();
    },

    onValidateCard() {
      this.isCartValidated = true;
      this._scrollToBottom();
    },

    onValidateSpecificities() {
      this.isSpecificitiesValidated = true;
      this._scrollToBottom();
    },

    _scrollToBottom() {
      if( this.datas || window.innerWidth < 768) return;
      setTimeout(() => {
        gsap.to(this.$refs.scroll, {duration: .6, scrollTo: 1200});
      }, 100);
    },

    _checkErrors() {
      if(this.form.cardOrderItem.value === '' || this.form.cardOrderItem.value === null || this.form.cardOrderItem.value < 1) {
        this.$refs['form-value'].classList.add('is-error');
        return true;
      }
      return false;
    },

    async sequenceCalls(calls) {
      const results = [];
      for (const call of calls) {
        const result = await call();
        results.push(result);
      }
      return results;
    },

    onSubmit(pEvt) {
      pEvt.preventDefault();
      if( this._checkErrors() ) return;
      this.errorMessage = null;
      if(this.isAddingItem) return;
      this.isAddingItem = true;
      let datas = JSON.parse(JSON.stringify( this.form ));
      datas.quantity = 1;
      if(datas.cardOrderItem.specificitiesSelect) {
        datas.cardOrderItem.specificities.push(datas.cardOrderItem.specificitiesSelect);
        delete datas.cardOrderItem.specificitiesSelect;
      }
      if(this.hasNoNumber) delete datas.cardOrderItem.customExtensionNumber;
      if(datas.cardOrderItem.year) datas.cardOrderItem.year = datas.cardOrderItem.year.toString();
      datas.variant = this.currentGame.productVariant ? this.currentGame.productVariant['@id'] : null;
      datas.cardOrderItem.value = datas.cardOrderItem.value * 100;
      for( let data in datas) {
        if(datas[data] === null) delete datas[data];
      }
      for( let data in datas.cardOrderItem) {
        if(datas.cardOrderItem[data] === null) delete datas.cardOrderItem[data];
      }
      if( this.datas && !this.isDupplicate ) {
        const cleanOptions = []
        this.form.cardOrderItem.options.forEach( option => {
          this.options.forEach(o => {
            if(o.variants[0]['@id'] === option) cleanOptions.push(option)
          });
        })
        this.form.cardOrderItem.options = cleanOptions;

        OrdersService.updateItem(this.datas.id, datas).then( (res) => {
          const calls = [];
          const optionsToDelete = this.datas.options.filter( option => {
            return !this.form.cardOrderItem.options.includes(option.variant['@id'])
          });

          const optionsToAdd = [...this.form.cardOrderItem.options];
          for( let i = optionsToAdd.length - 1; i >= 0; i--) {
            const option = optionsToAdd[i];
            this.datas.options.forEach( o => {
              if(option === o.variant['@id']) optionsToAdd.splice(i, 1);
            })
          }
          optionsToAdd.forEach( option => {
            calls.push( () => OrdersService.addItem({
              quantity: 1,
              variant: option,
              parentItem: res.data['@id']
            }))
          });
          optionsToDelete.forEach( option => {
            calls.push( () => OrdersService.deleteItem(option.id))
          });
          this.sequenceCalls(calls).then(() => {
            OrdersService.get().then( () => {
              this.isAddingItem = false;
              AppControlService.closeAddCard();
            })
          }).catch((err) => {
            this.isAddingItem = false;
            console.error(err);
            if(err.response && err.response.data && err.response.data['hydra:description']) this._setErrors(err.response.data['hydra:description'])
          })
        }).catch((err) => {
          this.isAddingItem = false;
          console.error(err);
          if(err.response && err.response.data && err.response.data['hydra:description']) this._setErrors(err.response.data['hydra:description'])
        });
      } else {
        OrdersService.addItem(datas).then( (res) => {
          const calls = [];
          this.form.cardOrderItem.options.forEach( option => {
            calls.push( () => OrdersService.addItem({
              quantity: 1,
              variant: option,
              parentItem: res.data['@id']
            }));
          })
          this.sequenceCalls(calls).then( () => {
            OrdersService.get().then( () => {
              AppControlService.closeAddCard();
              this.isAddingItem = false;
            })
          }).catch((err) => {
            this.isAddingItem = false;
            console.error(err);
            if(err.response?.data && err.response?.data['hydra:description']) this._setErrors(err.response.data['hydra:description'])
          })
        }).catch((err) => {
          this.isAddingItem = false;
          console.error(err);
          if(err.response?.data && err.response?.data['hydra:description']) this._setErrors(err.response.data['hydra:description'])
        })
      }
    },

    isCardValid() {
      if(this.currentGame) {
        switch (this.currentGame.code) {
          case 'pokemon':
            if(this.form.cardOrderItem.block && this.form.cardOrderItem.extension && this.form.cardOrderItem.year &&
                (this.form.cardOrderItem.customExtensionNumber !== '' || this.hasNoNumber)) return true;
            break;
          case 'yugioh':
            if(this.form.cardOrderItem.extensionCode && (this.form.cardOrderItem.customExtensionNumber !== '' || this.hasNoNumber) &&
                (this.currentGame.isExtensionOptional || this.form.cardOrderItem.extension) && (this.currentGame.isYearOptional || this.form.cardOrderItem.year)) return true;
            break;
          default:
            if((this.form.cardOrderItem.extensionCode || this.hasNoCode) && (this.currentGame.isExtensionOptional || this.form.cardOrderItem.extension) &&
                (this.currentGame.isYearOptional || this.form.cardOrderItem.year) && this.form.cardOrderItem.customExtensionNumber !== '') return true;
            break;
        }
      }
      return false;
    },

    _updateTotal() {
      this.total = null;
      if(!this.isCardValid()) return;
      if(this.currentGame && this.currentGame.productVariant) {
        GamesService.getTotalPrice(this.chooseGame, this.form.cardOrderItem.value * 100, this.form.cardOrderItem.serviceType ).then( res => {
          this.total = res.data.priceTtc / 100;
          if(this.form.cardOrderItem.insurance) this.total += parseFloat(this.insurance_value);
          if(this.form.cardOrderItem.options.length > 0) {
            this.options.forEach( product => {
              const variant = product.variants[0];
              if(this.form.cardOrderItem.options.includes(variant['@id'])) {
                this.total += variant.priceTtc / 100;
              }
            })
          }
        })
      }
    },

    _setErrors( error ) {
      this.errorMessage = error;
      clearTimeout(this._timeoutError);
      this._timeoutError = setTimeout(() => {
        this.errorMessage = null;
      }, 6000);
    },

    _getBlocks() {
      return new Promise((resolve) => {
        const datas = {
          game: this.currentGame['@id'],
          'cardExtensions.languages': this.form.cardOrderItem.language
        };
        if(!this.loadingMain) this.form.cardOrderItem.blocks = null;
        this.loadingBlock = true;
        GamesService.getBlocks(datas).then( res => {
          this.blocks = res.data['hydra:member'];
          if(this.blocks.length === 1 && !this.loadingMain) {
            this.form.cardOrderItem.block = this.blocks[0]['@id'];
            this.onChangeBlock();
          }
          resolve(res.data['hydra:member']);
        }).then( () => {
          this.loadingBlock = false;
        });
      });
    },

    _getExtensionsCode() {
      return new Promise((resolve) => {
        const datas = {
          game: this.currentGame['@id'],
          'cardExtensions.languages': this.form.cardOrderItem.language
        };
        if(this.currentGame.code === 'pokemon') {
          datas.cardExtensions = this.form.cardOrderItem.extension;
          datas.year = this.form.cardOrderItem.year;
        }
        if(!this.loadingMain) this.form.cardOrderItem.extensionCode = null;
        this.loadingExtensionCode = true;
        GamesService.getCodeExt(datas).then( res => {
          this.extensionsCode = res.data['hydra:member'];
          if(this.extensionsCode.length === 1 && !this.loadingMain) {
            this.form.cardOrderItem.extensionCode = this.extensionsCode[0]['@id'];
          }
          resolve(res.data['hydra:member']);
        }).then( () => {
          this.loadingExtensionCode = false;
        })
      });
    },

    _getYGO() {
      return Promise.all([this._getCodesYGO(), this._getLettersYGO()]);
    },

    _getCodesYGO() {
      return new Promise((resolve) => {
        if(!this.loadingMain) this.form.cardOrderItem.languageCodeYGO = null;
        this.loadingCodeYGO = true;
        GamesService.getCodesYGO({
          'language': this.form.cardOrderItem.language
        }).then( res => {
          this.codesYGO = res.data['hydra:member'];
          if(this.codesYGO.length === 1 && !this.loadingMain) this.form.cardOrderItem.languageCodeYGO = this.codesYGO[0]['@id'];
          resolve(res.data['hydra:member']);
        }).then( () => {
          this.loadingCodeYGO = false;
        });
      });
    },

    _getLettersYGO() {
      return new Promise((resolve) => {
        if(!this.loadingMain) this.form.cardOrderItem.additionnalLetterYGO = null;
        this.loadingLetterYGO = true;
        GamesService.getLettersYGO().then( res => {
          this.lettersYGO = res.data['hydra:member'];
          if(this.lettersYGO.length === 1 && !this.loadingMain) this.form.cardOrderItem.additionnalLetterYGO = this.lettersYGO[0]['@id'];
          resolve(res.data['hydra:member']);
        }).then( () => {
          this.loadingLetterYGO = false;
        });
      });
    },

    _getExtensions() {
      return new Promise((resolve) => {
        this.loadingExtension = true;
        if(!this.loadingMain) this.form.cardOrderItem.extension = null;
        const datas = {};
        if( this.currentGame.code === 'pokemon' ) {
          datas.block = this.form.cardOrderItem.block;
          datas.languages = this.form.cardOrderItem.language;
        } else {
          datas['block.game'] = this.currentGame['@id'];
          datas.languages = this.form.cardOrderItem.language;
          if(!this.hasNoCode) {
            datas.extensionCode =  this.form.cardOrderItem.extensionCode;
          }
        }
        GamesService.getExtensions(datas).then( res => {
          this.extensions = res.data['hydra:member'];
          if(this.extensions.length === 1 && !this.loadingMain) {
            this.form.cardOrderItem.extension = this.extensions[0]['@id'];
            this._getRangeYears();
          }
          resolve(res.data['hydra:member']);
        }).then(() => {
          this.loadingExtension = false;
        });
      })
    },

    _getRangeYears() {
      if(!this.loadingMain) this.form.cardOrderItem.year = null;
      var extension = GamesService.getExtension( this.form.cardOrderItem.extension, '@id' );
      if(extension) {
        var startDate = extension.startedAt || 1980,
            endedAt = extension.endedAt ? extension.endedAt : extension.stillActive ? currentYear : extension.startedAt;
        this.rangeYears = [...Array(endedAt-startDate+1).keys()].map(x => x+startDate).reverse();
        if(this.rangeYears.length === 1 && !this.loadingMain) {
          setTimeout(() => {
            this.form.cardOrderItem.year = this.rangeYears[0];
            if(this.currentGame.code === 'pokemon') this._getExtensionsCode();
          });
        }
      }
    },

    _getHelps(global = false) {
      return new Promise((resolve) => {
        this.loadingHelps = true;
        if(global) this.helpsGlobal = null;
        else this.helps = null;
        GamesService.getHelps({
          ...(this.chooseGame && { games: this.chooseGame }),
          ...(this.form.cardOrderItem.language && { languages: this.form.cardOrderItem.language })
        }).then( res => {
          if(global) this.helpsGlobal = {};
          else this.helps = {};
          res.data['hydra:member'].forEach(item => {
            if(global) {
              this.helpsGlobal[item.formKey] = {
                title: item.title,
                content: item.helpText
              }
            } else {
              this.helps[item.formKey] = {
                title: item.title,
                content: item.helpText
              }
            }
          });
          resolve(global ? this.helpsGlobal : this.helps);
        }).then(() => {
          this.loadingHelps = false;
        });
      })
    },

    _getSpecificities() {
      return new Promise((resolve) => {
        this.loadingSpecificities = true;
        this.specificitiesCheckbox = [];
        this.specificitiesSelect = [];
        this.specificitiesSelectHelps = [];
        GamesService.getSpecificities({
          games: this.chooseGame,
          languages: this.form.cardOrderItem.language
        }).then( res => {
          const specificities = res.data['hydra:member'];
          specificities.forEach(specificity => {
            if(specificity.displayMode === 'checkbox') {
              this.specificitiesCheckbox.push(specificity);
            }
            else if(specificity.displayMode === 'select') {
              this.specificitiesSelectHelps.push({
                title: specificity.name,
                content: specificity.helpText
              })
              this.specificitiesSelect.push(specificity);
            }
          });
          this.isSpecificitiesValidated = specificities.length === 0;
          resolve(res.data['hydra:member']);
        }).then(() => {
          this.loadingSpecificities = false;
        });
      })
    },

    _resetCart() {
      if(this.loadingMain) return;
      this.isCartValidated = false;
      this.blocks = null;
      this.extensions = null;
      this.extensionsCode = null;
      this.specificities = null;
      this.codesYGO = null;
      this.lettersYGO = null;
      this.hasNoCode = null;
      this.hasNoNumber = null;

      this.form.cardOrderItem.options = [];
      this.form.cardOrderItem.languageCodeYGO = null;
      this.form.cardOrderItem.additionnalLetterYGO = null;
      this.form.cardOrderItem.block = null;
      this.form.cardOrderItem.extension = null;
      this.form.cardOrderItem.extensionCode = null;
      this.form.cardOrderItem.year = null;
      this.form.cardOrderItem.customExtensionNumber = '';
    },

    _resetSpecificities() {
      if(this.loadingMain) return;
      this.isSpecificitiesValidated = false;
      this.form.cardOrderItem.specificities = [];
      this.form.cardOrderItem.specificitiesSelect = null;
    },

    _resetAssurance() {
      if(this.loadingMain) return;
      this.insurance_value = 0;

      this.form.cardOrderItem.value = '';
      this.form.cardOrderItem.insurance = false;
      this._updateTotal();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
<style lang="scss">
body.is-popin-help-open {
  .cart-wrapper {
    .scroll-container {
      -webkit-overflow-scrolling: initial !important;
    }
  }
}
</style>
<style scoped lang="scss">
.cart-add {
  position: fixed;
  bottom: 0;
  right: 0;
  width: 90%;
  max-width: rem(1000);
  background-color: $white;
  top: 0;
  z-index: 3;
  &.is-loading {
    .cart-form {
      @include loader;
      min-height: rem(400);
      & > * {
        display: none;
      }
    }
  }
  .scroll-container {
    -webkit-overflow-scrolling: touch;
  }
  .scroll-container,
  .ps {
    position: relative;
    overflow: auto;
    height: 100%;
    padding: rem(80) rem(20) rem(300);
    @include tablet {
      padding: rem(80) rem(30) rem(300);
    }
    @include desktop {
      padding: rem(70) rem(40) rem(300);
    }
    @include desktop-xl {
      padding: rem(100) rem(60) rem(300);
    }
  }
  .cart-add-error {
    @include visible;
    display: block;
  }
  .card-add-code-info {
    margin-bottom: rem(30);
    strong {
      color: $color-main;
    }
  }
  .std-form {
    position: relative;
    box-shadow: none;
    padding: 0;
    border-radius: 0;
    padding-top: rem(20);
    padding-bottom: rem(20);
    margin-left: 0;
    margin-right: 0;
    .form-label-container {
      white-space: nowrap;
      max-width: 90%;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .form-group {
      margin-bottom: rem(20);
      &.is-help {
        .form-control {
          padding-right: rem(55);
        }
      }
      &.form-group--is-select {
        .form-label-container {
          max-width: calc(90% - #{rem(15)});
        }
      }
    }
    .form-label {
      margin-bottom: rem(10);
    }
    .form-container {
      border-top: rem(1) solid $grey-light;
      margin-top: rem(40);
      padding-top: rem(40);
      width: 100%;
      @include tablet {
        width: 90%;
      }
      @include desktop {
        width: 80%;
      }
    }
    .form-control-group.form-control-group--suffix {
      & + .form-card-help {
        right: rem(40);
      }
    }
    .card-option-loader {
      @include loader;
      position: relative;
      width: 100%;
      min-height: rem(100);
    }
    .form-row.form-row--option {
      padding: rem(10) 0;
      border-radius: rem(8);
      box-shadow: 0 0 rem(6) rgba($black, .11);
      margin-bottom: rem(30);
      margin-left: 0;
      margin-right: 0;
      align-items: center;
      @include mobile {
        padding: rem(10) rem(15);
      }
      .cart-add-value {
        color: $color-main;
      }
      label {
        display: flex;
        align-items: center;
      }
      .checkbox-container {
        margin-left: rem(10);
      }
      .checkbox {
        margin-top: rem(10);
      }
      .checkbox-label {
        display: inline-block;
        color: $color-main;
        margin-right: rem(5);
      }
      .form-help {
        display: block;
        margin-left: 0;
      }
    }
    .form-row.form-row--value {
      align-items: center;
      .form-help {
        display: block;
      }
      label {
        display: flex;
        align-items: center;
      }
      .form-help {
        margin-left: 0;
      }
      .checkbox-container {
        margin-left: rem(10);
        flex: 1;
      }
    }
  }
  .cart-add-close {
    @include resetBtn;
    position: absolute;
    top: rem(30);
    right: rem(30);
    color: $blue-udark;
    border: rem(2) solid $blue-udark;
    transition: color $transition-out-hover, border-color $transition-out-hover;
    border-radius: 100%;
    width: rem(30);
    height: rem(30);
    line-height: rem(28);
    text-align: center;
    z-index: 2;
    &:hover, &:focus {
      color: $color-second;
      border-color: $color-second;
      transition: color $transition-in-hover, border-color $transition-in-hover;
    }
  }
  .cart-add-title {
    @include title(3);
  }
  .cart-add-subtitle {
    @include title(4);
    margin-bottom: rem(20);
  }
  .cart-add-total,
  .cart-add-value {
    font-weight: bold;
    color: $black;
  }
  .cart-add-value {
    text-align: right;
  }
  .radio-list {
    display: flex;
    align-content: center;
    justify-content: flex-start;
    width: 100%;
    @include mobile {
      flex-wrap: wrap;
    }
    &.radio-list--game {
      flex-wrap: wrap;
      .radio-list-element {
        width: 12.5%;
        flex: inherit !important;
      }
    }
    &.radio-list--small {
      .radio-list-element {
        width: rem(60);
        .radio-list-wrapper {
          padding-top: 70%;
          border-radius: rem(10);
        }
      }
      .radio-list-content {
        width: 50%;
        height: 80%;
      }
    }
    &:not(.radio-list--small) {
      .radio-list-element {
        @include mobile {
          width: rem(120);
        }
        @include tablet {
          flex: 1 0 0;
        }
      }
    }
    .radio-list-content {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 70%;
      text-align: center;
      transform: translateX(-50%) translateY(-50%);
    }
    .radio-list-element {
      padding-left: rem(5);
      padding-right: rem(5);
      margin-bottom: rem(10);
      .radio-list-wrapper {
        position: relative;
        display: block;
        border-radius: rem(10);
        box-shadow: 0 0 0 rem(1) $grey-light;
        width: 100%;
        padding-top: 45%;
        overflow: hidden;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      [type=radio] {
        @include hideAccess;
        // &:focus + .radio-list-wrapper {
        //   box-shadow: 0 0 0 rem(1) $color-main;
        // }
        & + .radio-list-wrapper.is-checked,
        &:checked + .radio-list-wrapper {
          box-shadow: 0 0 0 rem(2) $color-second;
        }
      }
      [type=radio][disabled] {
        &, & + .radio-list-wrapper {
          cursor: default;
        }
      }
      [type=radio][disabled]:not(:checked) + .radio-list-wrapper {
        opacity: .5;
      }
    }
  }
}
</style>
